import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ChatbotProvider } from './contexts/ChatbotContext';
import { MessagingProvider } from './contexts/MessagingContext';
import ProtectedRoute from './components/ProtectedRoute';
import ProtectedAdminRoute from './components/admin/ProtectedAdminRoute';
import ProtectedProfessionalRoute from './components/professional/ProtectedProfessionalRoute';
import ProtectedClientRoute from './components/client/ProtectedClientRoute';
import Chatbot from './components/Chatbot';
import HomePage from './pages/HomePage';
import PropertyListPage from './pages/PropertyListPage';
import PropertyDetailPage from './pages/PropertyDetailPage';
import AddPropertyPage from './pages/AddPropertyPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import DashboardPage from './pages/DashboardPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import ContactRequestsPage from './pages/admin/ContactRequestsPage';
import ContactRequestDetailPage from './pages/admin/ContactRequestDetailPage';
import VisitsCalendarPage from './pages/admin/VisitsCalendarPage';
import CommunicationsPage from './pages/admin/CommunicationsPage';
import AdminMessagesPage from './pages/admin/MessagesPage';
import ProfessionalDashboard from './pages/professional/ProfessionalDashboard';
import ProfessionalLeadsPage from './pages/professional/ProfessionalLeadsPage';
import ProfessionalVisitsPage from './pages/professional/ProfessionalVisitsPage';
import ProfessionalLeadDetailPage from './pages/professional/ProfessionalLeadDetailPage';
import ProfessionalMessagesPage from './pages/professional/MessagesPage';
import ClientDashboard from './pages/client/ClientDashboard';
import MyRequestsPage from './pages/client/MyRequestsPage';
import ClientRequestDetailPage from './pages/client/ClientRequestDetailPage';
import MyVisitsPage from './pages/client/MyVisitsPage';
import ClientMessagesPage from './pages/client/MessagesPage';
import FavoritesPage from './pages/client/FavoritesPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <MessagingProvider>
            <ChatbotProvider>
              <NotificationProvider>
                <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/properties" element={<PropertyListPage />} />
                <Route path="/properties/:id" element={<PropertyDetailPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />

                {/* Protected Routes */}
                <Route
                  path="/add-property"
                  element={
                    <ProtectedRoute requireProfessional={true}>
                      <AddPropertyPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute requireProfessional={true}>
                      <DashboardPage />
                    </ProtectedRoute>
                  }
                />

                {/* Admin Routes */}
                <Route
                  path="/admin"
                  element={
                    <ProtectedAdminRoute>
                      <AdminDashboard />
                    </ProtectedAdminRoute>
                  }
                />
                <Route
                  path="/admin/contact-requests"
                  element={
                    <ProtectedAdminRoute>
                      <ContactRequestsPage />
                    </ProtectedAdminRoute>
                  }
                />
                <Route
                  path="/admin/contact-requests/:id"
                  element={
                    <ProtectedAdminRoute>
                      <ContactRequestDetailPage />
                    </ProtectedAdminRoute>
                  }
                />
                <Route
                  path="/admin/visits"
                  element={
                    <ProtectedAdminRoute>
                      <VisitsCalendarPage />
                    </ProtectedAdminRoute>
                  }
                />
                <Route
                  path="/admin/communications"
                  element={
                    <ProtectedAdminRoute>
                      <CommunicationsPage />
                    </ProtectedAdminRoute>
                  }
                />
                <Route
                  path="/admin/messages"
                  element={
                    <ProtectedAdminRoute>
                      <AdminMessagesPage />
                    </ProtectedAdminRoute>
                  }
                />

                {/* Professional Routes */}
                <Route
                  path="/professional"
                  element={
                    <ProtectedProfessionalRoute>
                      <ProfessionalDashboard />
                    </ProtectedProfessionalRoute>
                  }
                />
                <Route
                  path="/professional/leads"
                  element={
                    <ProtectedProfessionalRoute>
                      <ProfessionalLeadsPage />
                    </ProtectedProfessionalRoute>
                  }
                />
                <Route
                  path="/professional/leads/:id"
                  element={
                    <ProtectedProfessionalRoute>
                      <ProfessionalLeadDetailPage />
                    </ProtectedProfessionalRoute>
                  }
                />
                <Route
                  path="/professional/visits"
                  element={
                    <ProtectedProfessionalRoute>
                      <ProfessionalVisitsPage />
                    </ProtectedProfessionalRoute>
                  }
                />
                <Route
                  path="/professional/messages"
                  element={
                    <ProtectedProfessionalRoute>
                      <ProfessionalMessagesPage />
                    </ProtectedProfessionalRoute>
                  }
                />

                {/* Client Routes */}
                <Route
                  path="/client"
                  element={
                    <ProtectedClientRoute>
                      <ClientDashboard />
                    </ProtectedClientRoute>
                  }
                />
                <Route
                  path="/client/my-requests"
                  element={
                    <ProtectedClientRoute>
                      <MyRequestsPage />
                    </ProtectedClientRoute>
                  }
                />
                <Route
                  path="/client/my-requests/:id"
                  element={
                    <ProtectedClientRoute>
                      <ClientRequestDetailPage />
                    </ProtectedClientRoute>
                  }
                />
                <Route
                  path="/client/my-visits"
                  element={
                    <ProtectedClientRoute>
                      <MyVisitsPage />
                    </ProtectedClientRoute>
                  }
                />
                <Route
                  path="/client/messages"
                  element={
                    <ProtectedClientRoute>
                      <ClientMessagesPage />
                    </ProtectedClientRoute>
                  }
                />
                <Route
                  path="/client/favorites"
                  element={
                    <ProtectedClientRoute>
                      <FavoritesPage />
                    </ProtectedClientRoute>
                  }
                />
              </Routes>

              {/* Chatbot - Available on all pages */}
              <Chatbot />
            </NotificationProvider>
          </ChatbotProvider>
        </MessagingProvider>
      </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;